export default __webpack_public_path__ + "static/media/ysd-koshiki2.0c73e715.jpg";